export default "__VITE_ASSET__B$hG1gsV__"